__turbopack_context__.v({
  "sticker": "_3hItmG_sticker",
});
